<template>
  <div>
    <vue-flux
      :options="vfOptions"
      :images="vfImages"
      :transitions="vfTransitions"
      :captions="vfCaptions"
      ref="slider"
    >
      <template v-slot:parallax>
        <flux-parallax :src="vfImages[0]" style="height: 300px">
          <div color="white">CONTENT</div>
          <div>CONTENT</div>
          <div>CONTENT</div>
        </flux-parallax>
      </template>

      <template v-slot:preloader>
        <flux-preloader />
      </template>

      <template v-slot:caption>
        <flux-caption />
      </template>

      <template v-slot:controls>
        <flux-controls />
      </template>

      <template v-slot:pagination>
        <flux-pagination />
      </template>

      <template v-slot:index>
        <flux-index />
      </template>
    </vue-flux>

    <!-- <button @click="$refs.slider.show('next')">NEXT</button> -->
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
  FluxParallax,
} from "vue-flux";

export default {
  props: ["images"],
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  mounted() {
    this.vfImages = this.images;
  },
  watch: {
    images(newVal, oldVal) {
      this.vfImages = newVal;
    },
  },
  data() {
    return {
      onboarding: 0,
      vfOptions: {
        autoplay: true,
        aspectRatio: "9:5",
      },
      vfImages: [],
      vfTransitions: [
        "fade",
        "kenburn",
        "cube",
        "book",
        "wave",
        "cube",
        "book",
        "swipe",
        "slide",
        "waterfall",
        "fall",
        "wave",
        "blinds 2d",
        "blocks 1",
        "blocks 2",
        "blinds 3d",
        "round 1",
        "concentric",
        "zip",
        "camera",
        "round 2",
        "explode",
        "warp",
      ],
      vfCaptions: [],
    };
  },
  components: {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
    FluxParallax,
  },
};
</script>
